import * as React from 'react';

import { translate } from '~l10n/client';

import { UIButton } from '~shared/components/buttons';
import { DialogProps } from '~shared/components/Dialog';
import {
  PaywallDialog,
  PaywallFeatureList,
  PaywallTouch,
  PaywallUpgradeButton,
} from '~teacher/components/PaywallDialog';

export type Props = Pick<DialogProps, 'open' | 'onClose'> & {
  paywallTouch: PaywallTouch;
};

export function QuizEditorPaywall(props: Props) {
  const features = [
    {
      text: translate('Custom question weights'),
      url: 'https://help.socrative.com/en/articles/5100205-weighted-questions',
    },
    {
      text: translate('Math equations'),
      url: 'https://help.socrative.com/en/articles/4188711-inserting-math-equations',
    },
    {
      text: translate('Images in answers'),
    },
  ];

  return (
    <PaywallDialog.Long
      id="quiz-editor-paywall"
      title={translate('Upgrade to Access Pro Question Features')}
      actions={[
        <UIButton key="cancel" onClick={props.onClose}>
          {translate('Cancel')}
        </UIButton>,
        <PaywallUpgradeButton
          key="upgrade"
          appearance="primary"
          paywallScreen={props.paywallTouch[0]}
        />,
      ]}
      {...props}
    >
      <p className="m-0 pb-4 text-blue-900">
        {translate(
          'Pro question features let you quiz deeper and collect richer feedback with:'
        )}
      </p>
      <PaywallFeatureList features={features} />
    </PaywallDialog.Long>
  );
}
